/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderCancelBody
 */
export interface OrderCancelBody {
    /**
     * 
     * @type {string}
     * @memberof OrderCancelBody
     */
    cancellationReason?: string;
}

/**
 * Check if a given object implements the OrderCancelBody interface.
 */
export function instanceOfOrderCancelBody(value: object): value is OrderCancelBody {
    return true;
}

export function OrderCancelBodyFromJSON(json: any): OrderCancelBody {
    return OrderCancelBodyFromJSONTyped(json, false);
}

export function OrderCancelBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCancelBody {
    if (json == null) {
        return json;
    }
    return {
        
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
    };
}

export function OrderCancelBodyToJSON(json: any): OrderCancelBody {
    return OrderCancelBodyToJSONTyped(json, false);
}

export function OrderCancelBodyToJSONTyped(value?: OrderCancelBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancellationReason': value['cancellationReason'],
    };
}

